import { render } from "./EmailSubscription.vue?vue&type=template&id=72cfcbb4&scoped=true"
import script from "./EmailSubscription.vue?vue&type=script&lang=js"
export * from "./EmailSubscription.vue?vue&type=script&lang=js"

import "./EmailSubscription.vue?vue&type=style&index=0&id=72cfcbb4&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72cfcbb4"]])

export default __exports__